module.exports = __webpack_public_path__ + "static/01-59ff95229856e3930e0339608ec7109a.jpg";